import { deepClone } from "../../util";
import { saveOptions } from "../../data/storage";

export const SET_PRIZES = (state, prizes) => {
  state.prizes = prizes.sort((a,b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
}

export const SET_LOADING = (state, status) => {
  state.isLoading = status
}

export const REMOVE_PRIZES_FROM_LIST = (state, prize) => {
  // console.log('prize with id ', prize, ' removed')
  state.prizes = state.prizes.filter(item => {
    return item.prizes.id !== prize.id
  })
}

export const SET_WINNERS = (state, winner) => {
  state.winners.push(winner)
}

// Save current prize data to storage, and reset the prize list.
export const saveAndResetDoorprize = state => {
  state.lastResult = -1;
  // console.log("masuk ke mutation prizes", state.prizes)
  saveOptions(state.prizes, 'prizeLists');
};

//  make the last prize list spinned unavailable.
export const updateAvailableDoorprize = state => {
  if (state.lastResult !== -1) {
    state.prizes.splice(state.lastResult, 1);
    // console.log(state.prizes, "<< spliced prizes")
    state.lastResult = -1;
  }
};

export const removeDoorprize = (state, index) => {
  state.prizes.splice(index, 1);
  // console.log(state.prizes, "<< updated state prizes")
  let temp = JSON.parse(localStorage.getItem("prizeLists"))
  temp.splice(index, 1)
  
  localStorage.setItem("prizeLists", JSON.stringify(temp))

  if (localStorage.getItem("prizeLists") && localStorage.getItem("prizeLists").length === 0) {
    localStorage.removeItem("prizeLists")
  }
};
